import type { EntityConfig } from "@/v2/framework/registry/types";
import { createPlayersView } from "./grid/view";

export default {
  id: "players",
  name: "players",
  title: "metadata.players",
  position: 8,
  create: (ctx) => createPlayersView(ctx),
} satisfies EntityConfig;
